var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-inline m-0 pl-lg-3 d-flex justify-content-center flex-wrap flex-lg-nowrap social-links"},_vm._l((_vm.items),function(link){return _c('social-link',{key:link.title,attrs:{"link":link}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }